module.exports = {
  lackParameter: '缺乏参数',
  emptyTxt: '暂无数据',
  coupon: '我的优惠券'
}